import React, { Component } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import IconButton from "@mui/material/IconButton";
import Theme from "../Theme";
import SummaryModul from "../SummaryModul";
import MessageModul from "../../MessageModul";
import DataStore from "../../stores/DataStore";

class AccordionModul extends Component {
  constructor(params) {
    super(params);
    this.messageModules = [];
    this.state = { summaryVisible: false };
    this.DataStore = DataStore;
    this.messageHandler = this.DataStore.getHandler().messageHandler;
  }

  getSummary() {
    this.saveChangesHandler = DataStore.getHandler().saveChangesHandler;
    const summary = <SummaryModul />;
    return summary;
  }

  getMessageModul() {
    return (
      <MessageModul
        onMounted={(modul) => {
          this.messageModul = modul;
          this.messageHandler.setMessageModul(this.messageModul);
        }}
        messageHandler={this.messageHandler}
      />
    );
  }

  getAccordion() {
    const {
      themes = [],
      // attributes = [],
      debug,
      // messageHandler,
      editToolbar,
    } = this.props;
    const accordionContent = [];
    themes.forEach((theme) => {
      const { alwaysOpen } = theme;
      const innerTheme = (
        <Theme
          themeOptions={theme}
          // messageModul={this.getMessageModul()}
          debug={debug}
          editToolbar={editToolbar}
        />
      );
      const accSumm = (
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>{theme.title}</Typography>
        </AccordionSummary>
      );
      const accDet = <AccordionDetails>{innerTheme}</AccordionDetails>;
      if (!alwaysOpen)
        accordionContent.push(
          <Accordion>
            {accSumm}
            {accDet}
          </Accordion>
        );
      else {
        accordionContent.push(innerTheme);
      }
    });
    return accordionContent;
  }

  getFooter() {
    if (DataStore.requestStore.requests[DataStore.saveKey] === undefined) {
      return <div />;
    }
    return (
      <div>
        <IconButton
          aria-label="send"
          onClick={() => {
            this.handleSend();
          }}
        >
          <SendRoundedIcon />
        </IconButton>
      </div>
    );
  }

  handleSend() {
    const { saveChangesHandler } = DataStore.getHandler();
    saveChangesHandler.saveChanges(
      () => {
        this.setState({
          summaryVisible: true,
        });
        this.messageModul.reset();
      },
      (errorLog) => {
        const errDetail = errorLog.map((o) => (
          <div>
            <div style={{ float: "left", marginRight: "5px" }}>
              {`${o.name}: `}
            </div>
            {o.errText.map((t) => (
              <div>{t}</div>
            ))}
          </div>
        ));
        this.messageHandler.logDebugFormatted(
          "PagesModul",
          "handleSendErrorAnonym",
          "",
          this.props,
          this.state,
          errorLog
        );
        this.messageHandler.setMessage(
          "error",
          "Fehler im Formular",
          errDetail
        );
        this.setState({ summaryVisible: false });
      }
    );
  }

  render() {
    const { summaryVisible } = this.state;
    // const { themes = [], attributes = [] } = this.props;
    const messageModul = this.getMessageModul();
    return (
      <div>
        {this.getAccordion()}
        {this.getFooter()}
        <div style={{ display: summaryVisible ? "block" : "none" }}>
          {this.getSummary()}
        </div>
        {messageModul}
      </div>
    );
  }
}

export default AccordionModul;
